<template>
  <div>
    <div class="md-layout md-gutter">
      <div
        class="md-layout-item md-large-size-50 md-medium-size-50 md-xlarge-size-50 md-small-size-100 md-small-size-100"
      >
        <agent-detail :agent-id="agentId" />
      </div>

      <div
        class="md-layout-item md-large-size-50 md-medium-size-50 md-xlarge-size-50 md-small-size-100 md-small-size-100"
      >
        <agent-receipt-list :agent-id="agentId" />
      </div>
      <div
        class="md-layout-item md-large-size-50 md-medium-size-50 md-xlarge-size-50 md-small-size-100 md-small-size-100"
      >
        <agent-balance-history-list :agent-id="agentId" type="balance" />
        <agent-balance-history-list :agent-id="agentId" type="commission" />
      </div>

      <div
        class="md-layout-item md-large-size-50 md-medium-size-50 md-xlarge-size-50 md-small-size-100 md-small-size-100"
      >
        <assigned-appliance-list
          v-if="$can('appliances')"
          :agent-id="agentId"
        />
        <sold-appliance-list v-if="$can('appliances')" :agent-id="agentId" />
        <agent-ticket-list v-if="$can('tickets')" :agent-id="agentId" />
      </div>
      <div
        v-if="$can('transactions')"
        class="md-layout-item md-large-size-100 md-medium-size-100 md-xlarge-size-100 md-small-size-100 md-small-size-100"
      >
        <agent-transaction-list :agent-id="agentId" />
      </div>
    </div>
  </div>
</template>
<script>
import AgentDetail from "./AgentDetail.vue"
import AgentTicketList from "./AgentTicketList.vue"
import AgentTransactionList from "./AgentTransactionList.vue"
import AssignedApplianceList from "./Appliances/AssignedApplianceList.vue"
import SoldApplianceList from "./Appliances/SoldApplianceList.vue"
import AgentBalanceHistoryList from "./Balance/AgentBalanceHistory.vue"
import AgentReceiptList from "./Receipt/AgentReceiptList.vue"

export default {
  name: "Agent",
  data() {
    return {
      agentId: null,
    }
  },
  components: {
    AgentBalanceHistoryList,
    AgentTicketList,
    AgentTransactionList,
    SoldApplianceList,
    AgentReceiptList,
    AssignedApplianceList,
    AgentDetail,
  },
  created() {
    this.agentId = this.$route.params.id
  },
  methods: {},
}
</script>
<style scoped lang="scss"></style>
